export default {
  rewardsHome: {
    title: 'Cashback',
    viewAllCategories: 'View all categories',
    earningsToDate: 'Earnings to Date',
  },
  nearByOffer: {
    header: 'Cashback nearby',
    openInMaps: 'Open in Maps',
    requestLocationTitle:
      'Turn on location access to explore cashback offers near you',
    requestLocationBody:
      'Update your location permission for Varo in your device settings.',
  },
  nearbyMap: {
    title: 'Nearby',
    loading: 'Loading...',
    buttonLabel: 'View map',
    noOffersTitle: 'No offers nearby',
    noOffersMessage:
      'Zoom out or explore different categories to find the offers near you.',
    findingOffers: 'Finding offers...',
    noOffersNearby: 'No offers nearby',
    offersNearby: 'offers nearby',
  },
  upsideOffers: {
    legalText: 'Varo Bank Cashback Program Addendum',
    pdfUrl:
      'https://uat-cdn.varomoney.com/agreements/a762f560-8f6b-48fd-b1d7-e09d65bd55d8.pdf',
    activate: 'activate',
    activateToUse: 'Activate to use',
    mapView: 'Map View',
    getDirections: 'Get Directions',
    snackbarText: 'Offer failed to activate.',
    deactivatedSnackbarText: 'Offer failed to deactivate.',
    offerDetailsNotFound: 'Offer details not found',
    deactivate: 'Deactivate',
    PrimaryButton: 'Done',
  },

  myActivity: {
    title: 'My cashback',
    loading: 'Loading...',
    lifetimeEarnings: 'Lifetime earnings',
    noCashbackTitle: 'You haven’t earned any Cashback',
    noCashbackMessage:
      'Get up to 6% cashback at select brands when you use your Varo cards. So every time you pay, you’re treating yourself.',
    buttonLabel: 'See offers',
  },
  myOffers: {
    title: 'My offers',
    loading: 'Loading...',
    noActivatedOffersTitle: 'You haven’t activated any offers',
    noActivatedOffersMessage:
      'Once you activate an offer, it will appear here. You can have up to 5 activated at a time.',
    active: 'Active',
    pending: 'Pending',
    activeTitle: 'Activated offers',
    activeSubtitle: '5 maximum',
    pendingTitle: 'Pending offers',
    pendingSubtitle:
      'Offers will remain here for 10 days while they are processed.',
    noActiveOffersTitle: 'No active offers',
    noActiveOffersMessage:
      'Activate an offer to see it here. You can keep up to 5 active at a time.',
    footerMessage: 'You can have 5 active offers daily.',
    noPendingOffersTitle: 'No pending offers',
    noPendingOffersMessage:
      'It can take up to 10 days for pending offers to process.',
    inlineAlertMessage:
      'You’ve already redeemed 5 offers today. Your daily limit resets tomorrow.',
  },
  cashbackTransactionDetails: {
    cashbackTitle: 'Cashback detail',
    transactionTitle: 'Transaction details',
    loading: 'Loading...',
    description: 'Description',
  },
  rewardsCategories: {
    allCategoriesText: 'All Categories',
    categoriesText: 'Categories',
    all: 'All',
  },
  selfFundedOffers: {
    activateButtonTitle: 'Activate',
    error: {
      buttonTitle: 'Done',
    },
    activatedOffer: {
      viewOfferDetails: 'View offer details',
      backToCashback: 'Back to cashback',
    },
  },
  browseByCategory: {
    title: 'Browse by Category',
    nearby: 'Nearby',
    allPrefix: 'All',
    allCategories: 'All Categories',
    cashback: 'cashback',
    noOffersTitle: 'No offers available',
    noOffersMessage:
      'There are currently no offers in this category. Please try another category.',
    errorAnalyticsKey: 'browseByCategoryError',
    locationPermissionDenied: 'Permission to access location was denied',
    locationError: 'Error getting location',
    mapViewComingSoon: 'Map View Coming Soon',
  },
  homeOfferCard: {
    activateButtonTitle: 'Activate my bonus',
  },
  deactivateBottomSheet: {
    title: 'Deactivate this offer?',
    bodyMessage:
      'To earn cashback, the offers must stay active until it expires. If you’ve already made a purchase, you won’t earn rewards if you deactivate it early.',
    buttonTitle: 'Deactivate',
    cancelButtonTitle: 'Cancel',
    snackbarText: 'Offer failed to deactivate',
  },
  offerDetails: {
    title: 'Grocery',
    cashbackText: '5% cashback',
    statusTag: 'Active',
    statusText: 'Valid until Oct 31 at 11:59 PM MT',
    howItWorksStep1: 'Use online and in-store',
    howItWorksStep2: 'Use any Varo card',
    howItWorksStep3: 'Earn up to $10',
  },
  nearbyOffersCarousel: {
    viewAll: 'View all',
  },
  partnerOffersDetails: {
    notFoundTitle: 'Offer Details Not Found',
    notFoundMessage: 'Could not find the offer details you are looking for.',
  },
  listItem: {
    activateButton: 'Activate',
    featuredOfferTitle: '{{subTitle}} at {{title}}',
  },
  rewardsMap: {
    searchThisAreaButton: 'Search this area',
  },
};
